// extracted by mini-css-extract-plugin
export default {"block":"block--KyVDJ","block_selected":"block_selected--sEUMx","name":"name--zzO7O","tag":"tag--i_Oak","date":"date--siA4b"};